import Style from "./style"

const DefaultInput = ({ children, label, type, inputRef, placeholder }) => {

    return (
        <Style.Wrapper>
            {label && <h2>{label}<span>*</span></h2>}

            <Style.InputDiv>
                <input type={type || "text"} ref={inputRef} placeholder={placeholder} />
                <div>{children}</div>
            </Style.InputDiv>
        </Style.Wrapper>
    )
}

export default DefaultInput